var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMlpCustom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#101233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8634 8.30334L9.6032 8.77822L12.3264 4.61566L12.8634 8.30334Z",
    fill: "#CAFFCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8605 28.887L14.2202 29.1257L7.05856 14.2246L7.3792 13.7344L13.5238 12.8397L15.8605 28.887Z",
    fill: "#CAFFCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4474 7.1987L17.1872 7.67358L16.64 3.91742L20.4474 7.1987Z",
    fill: "#CAFFCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3917 11.8425L21.5443 28.0595L20.1843 28.2579L17.8477 12.2099L23.8086 11.3414L24.3917 11.8425Z",
    fill: "#CAFFCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2579 10.3059L23.8739 7.67043L16.375 8.76227L15.5181 2.87427L13.0938 3.22691L13.9514 9.11555L6.45248 10.2074L6.83648 12.8429L14.3354 11.7511L16.8109 28.7488L19.2346 28.3955L16.759 11.3978L24.2579 10.3059Z",
    fill: "#03F5AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMlpCustom);
export default __webpack_public_path__ + "static/media/ic_mlp_custom.cba13305e165f6efb09a444a513e3561.svg";
export { ForwardRef as ReactComponent };